import _ from "lodash";
import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { trim, BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  openChallengesModal,
  insertChallenge,
  getMaxDisplayorder,
  fetchManageChallengesList,
} from "ManagechallengesActions";
import {
  COMMON_FAIL_MESSAGE,
  BASE_IMAGES_URL,
  ATTACHEMNT_REQUIRED_MESSAGE,
  ACCESS_FILES_API_KEY,
  maxLengthObjectFc,
} from "Constants";
import { checkContentDashboardStatus } from "GeneralTabAction";
import InlineCropper from "InlineCropper";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
const notApplicableNameArr = [
  "completeprofile",
  "globalsearch",
  "communitygetlike",
  "communitygetcomment",
]; // Note : - Profile picture/interest/looking for something for these challenges the pop up will be shown as “Not applicable”

class EditChallenge extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      linkFieldName: "",
      linkFieldLable: "",
      callFor: "",
      isshowUpload: true,
      imagePreviewUrl: "",
      imageSelected: true,
      flag: true,
      flag1: true,
      rewardtype: this.props.initialValues.rewardtype,
    };

    this.close = this.close.bind(this);
    this.onImageSave = this.onImageSave.bind(this);
    this.cropperRef = React.createRef();
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });
    this.props.autofill("award", img);
  };

  saveImage = (callback) => {
    if (this.state.imageAvailable) {
      this.cropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if(this.state.flag){
    // }
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
    // Max display order call
    this.props.getMaxDisplayorder(this.props.session, (CallBackResponse) => {});
  }

  // Modal Close [add/edit]
  close() {
    this.props.reset();
    this.props.openChallengesModal({ showModal: false });
    this.setState({ isshowUpload: true });
    this.setState({ imagePreviewUrl: "" });
    this.setState({ rewardtype: "" });
  }

  // On Form Submit Challenges
  onFormSubmit(values) {
    if (values.rewardtype == "award") {
      // Validation If award

      if (values.hasOwnProperty("option")) {
        if (
          values.option == "upload" &&
          (values.award == "" ||
            values.award == "null" ||
            values.award == "null")
        ) {
          this.props.showError(ATTACHEMNT_REQUIRED_MESSAGE);
          return false;
        }
      }

      // If Reward Type Award Make Points to blank / null / 0
      if (values.hasOwnProperty("points")) {
        values["points"] = 0;
      }

      if (parseInt(values.isrecurring) === 1 || values.isrecurring === "1") {
        this.props.showError(
          "'Award' type can't be selected if 'IS recurring' is Yes"
        );
        return false;
      }
    }

    var searchVal = document.getElementById(
      "gamification_manage_challenges_searchid"
    ).value;

    var maxDisplayOrderObj = this.props.maxDisplayorder.data;
    var data = { ...values };
    var challenge = this.props.initialValues;

    // If initialValues is blank time of add
    if (Object.keys(challenge).length == 0) {
      var keys = Object.keys(maxDisplayOrderObj);
      var displayorder = keys[0];
      values = { ...values, displayorder };
      values.displayorder = maxDisplayOrderObj.displayorder;
      data = { ...values };
    }

    this.setState({ loading: true });

    this.props.insertChallenge(
      this.props.session,
      data,
      challenge,
      (result) => {
        if (result.error) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.reset();
          this.close();
          this.props.showSuccess("Challenge updated successfully!");
          this.props.checkContentDashboardStatus(this.props.session);

          /**** Refresh table data after form submit ****/

          if (
            this.props.managechallengesSelectedTab == "MANAGECHALLENGES_SINGLE"
          ) {
            // Single Challenge
            this.props.fetchManageChallengesList(
              this.props.session,
              searchVal,
              "single",
              (CallBackResponse) => {}
            );
          } else {
            // For Recurring Chaleenges call
            this.props.fetchManageChallengesList(
              this.props.session,
              searchVal,
              "recurring",
              (CallBackResponse) => {}
            );
          }
        }
        this.setState({ loading: false });
      }
    );
  }

  // Custom Render option
  renderFieldRadio1(field) {
    return (
      <div className="" style={{ display: "inline" }}>
        <label
          className="custom-container-radio"
          style={{ marginRight: "20px" }}
        >
          {field.label}
          <input {...field.input} type={field.type} checked={field.checked} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  onOptionChange = (e) => {
    let clickedValue = e.target.value;

    this.props.initialValues.option = clickedValue;
    if (clickedValue == "upload") {
      this.setState({ isshowUpload: true });
    } else {
      this.setState({ isshowUpload: false });
    }
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });

    if (imageAvailable) {
      this.setState({ imageSelected: true });
    } else {
      this.setState({ imageSelected: false });
    }
  };

  /**** On Reward Type Change ****/
  _handelRewardTypeChange = (e) => {
    // For Default radio button selection
    if (e.target.value === "award") {
      this.props.initialValues.option = "upload";
    }

    this.setState({ rewardtype: e.target.value });
  };

  /*** Custom Render Select ***/
  renderSelectCustom(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (field.labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <select
            className="form-control dropdown-height-border bg-disabled"
            {...field.input}
            disabled={field.disabled}
          >
            {field.placeholder ? (
              <option value="" key={field.label}>
                {field.placeholder}
              </option>
            ) : (
              ""
            )}
            {field.opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.name ? object.name : object.text}
                </option>
              );
            })}
          </select>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let isRecurringState = "";
    var { imagePreviewUrl, isshowUpload, rewardtype } = this.state;

    if (_.isEmpty(rewardtype)) {
      rewardtype = this.props.initialValues.rewardtype;
    }

    if (!_.isEmpty(this.props.initialValues)) {
      isRecurringState = this.props.initialValues.isrecurring;
    }

    var { handleSubmit, pristine, reset, submitting, invalid } = this.props;

    if (this.props.initialValues && this.props.initialValues.award) {
      imagePreviewUrl = `${BASE_IMAGES_URL}/${this.props.initialValues.award}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    // Option -> Upload / Choose Template
    if (this.props.initialValues && this.props.initialValues.option) {
      if (this.props.initialValues.option == "html") {
        isshowUpload = false;
      } else {
        isshowUpload = true;
      }
    }

    // Modal Header Text
    var modalHeaderText =
      Object.keys(this.props.initialValues).length > 0 ? "Edit" : "Add";

    var challengetypeOptions = [];

    var rewardtypeOptions = [];

    if (parseInt(isRecurringState) === 1) {
      rewardtypeOptions = [
        {
          name: "point",
          value: "point",
        },
      ];
    } else {
      rewardtypeOptions = [
        {
          name: "point",
          value: "point",
        },
        {
          name: "award",
          value: "award",
        },
      ];
    }

    var isrecurringOptions = [
      {
        name: "YES",
        value: 1,
      },
      {
        name: "NO",
        value: 0,
      },
    ];

    var showpopupOptions = [
      {
        name: "YES",
        value: 1,
      },
      {
        name: "NO",
        value: 0,
      },
    ];

    // Putting values into challengetypeOptions for challengetype
    _.forEach(
      [
        "completeprofile",
        "makeconnection",
        "attendsession",
        "sendmessage",
        "openapp",
        "bookmarkitem",
        "ratesession",
        "liveqa",
        "speakers",
        "exhibitors",
        "sponsor",
        "news",
        "qr",
        "social",
        "community",
        "gallerypost",
        "survey",
        "globalsearch",
        "exhibitor",
      ],
      function (value) {
        var obj = {
          name: value,
          challengetypeVal: value,
        };
        challengetypeOptions.push(obj);
      }
    );

    return (
      <div>
        <Modal
          className="modal-container"
          show={this.props.modalData.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          enforceFocus={false}
        >
          <form
            onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
            encType="multipart/form-data"
          >
            <Modal.Header>
              {/* <Modal.Title>{modalHeaderText} Challenge</Modal.Title> closeButton*/}
              <div
                className="import-modal-title"
                style={{ paddingLeft: "28px" }}
              >
                {modalHeaderText}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.close()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="tab-content">
                <div className="form-group">
                  <Field
                    name="challengename"
                    label="Challenge Name"
                    placeholder="Challenge Name"
                    type="text"
                    component={this.renderFieldText}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={
                      MAXLENOBJ.challengename ? MAXLENOBJ.challengename : ""
                    }
                  />
                </div>
                <div className="form-group">
                  <Field
                    name="challengedesc"
                    label="Description"
                    placeholder="Description"
                    type="text"
                    component={this.renderFieldText}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    maxlength={
                      MAXLENOBJ.challengedesc ? MAXLENOBJ.challengedesc : ""
                    }
                  />
                </div>
                <div className="form-group">
                  <Field
                    name="rewardtype"
                    label="Reward Type"
                    placeholder="SELECT"
                    component={this.renderSelect}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    opts={rewardtypeOptions}
                    onChange={this._handelRewardTypeChange.bind(this)}
                    // value={this.props.initialValues.rewardtype}
                    // input={{ disabled: true,value: this.props.initialValues.rewardtype}}
                  />
                </div>
                {rewardtype === "award" ? (
                  <div>
                    <div className="form-group">
                      <Field
                        name="option"
                        label={LocaleStrings.gamification_submenu_title4}
                        component={this.renderFieldRadio}
                        type="radio"
                        value="upload"
                        onChange={this.onOptionChange.bind(this)}
                      />{" "}
                      <Field
                        name="option"
                        label={LocaleStrings.gamification_submenu_title5}
                        component={this.renderFieldRadio}
                        type="radio"
                        value="html"
                        onChange={this.onOptionChange.bind(this)}
                      />
                    </div>
                    {isshowUpload ? (
                      <div className="form-group">
                        <label className="control-label-top col-md-12">
                          Certificate<span className="label-mandatory">*</span>
                        </label>
                        <div className="col-md-12">
                          <InlineCropper
                            imgwidth={1400}
                            imgheight={560}
                            width={560}
                            height={300}
                            border={2}
                            onImageSave={this.onImageSave}
                            onImageChange={this.onImageChange}
                            imagepath={imagePreviewUrl}
                            imageType="png"
                            ref={this.cropperRef}
                          />
                          <div className="image-subtitle-info">
                            * Recommended image size - 560 wide x 300 tall
                          </div>
                          <Field
                            name="award"
                            component={this.renderHiddenFieldText}
                          />
                        </div>
                      </div>
                    ) : (
                      <Field
                        name="award_template"
                        label={
                          LocaleStrings.gamification_rewardsettings_template
                        }
                        placeholder="Enter Text"
                        mandatory="true"
                        type="minimal"
                        component={this.renderRichTextareaWithLabelTinymce}
                        cssImport={`${BASE_IMAGES_URL}/eventify/gamification/certificatehtml/css/canvas.css?api_key=${ACCESS_FILES_API_KEY}`}
                        labelposition={LABEL_POSITION_TOP}
                        height={400}
                      />
                    )}
                  </div>
                ) : (
                  <Field
                    name="points"
                    label="Points"
                    placeholder="Points"
                    type="number"
                    component={this.renderFieldText}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                  />
                )}

                <div>
                  <Field
                    name="isrecurring"
                    label="Is recurring"
                    placeholder="SELECT"
                    component={this.renderSelectCustom}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    opts={isrecurringOptions}
                    disabled={true}
                  />
                </div>
                <div
                  className={
                    _.indexOf(
                      notApplicableNameArr,
                      this.props.initialValues.challengetype
                    ) > -1
                      ? "hidden"
                      : ""
                  }
                >
                  <Field
                    name="showpopup"
                    label="Show popup"
                    placeholder="SELECT"
                    component={this.renderSelect}
                    mandatory="true"
                    labelposition={LABEL_POSITION_TOP}
                    opts={showpopupOptions}
                    value={this.props.initialValues.showpopup}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.close}>Close</Button>
              <Button
                className="btn btn-custom-blue ml-10"
                loading={this.state.loading}
                type="submit"
                disabled={pristine || invalid || submitting}
              >
                Save Changes
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function validate(values, props) {
  var errors = {};

  var requiredFields = [];
  var maxLengthFields = ["challengename", "challengedesc"];
  /* If Award seleted */
  if (values.rewardtype == "award") {
    if (values.hasOwnProperty("option")) {
      if (values.rewardtype == "upload") {
        // If upload option selected Image is mandatory
        requiredFields = [
          "challengename",
          "challengedesc",
          "rewardtype",
          "challengetype",
          "isrecurring",
          "showpopup",
          "award",
        ];
      } else {
        // If Template option selected Template is mandatory
        requiredFields = [
          "challengename",
          "challengedesc",
          "rewardtype",
          "challengetype",
          "isrecurring",
          "showpopup",
          "award_template",
        ];
      }
    }
  } else {
    /* If Point seleted */
    requiredFields = [
      "challengename",
      "challengedesc",
      "rewardtype",
      "challengetype",
      "points",
      "isrecurring",
      "showpopup",
    ];
  }

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  // Code change ~ Tapas
  // let regexp =  /^(?:(ftp|http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}$/;
  let regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

  requiredFields.forEach((field) => {
    let value = values[field];
  });

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    modalData: state.challengeModel,
    initialValues: state.challenge,
    maxDisplayorder: state.maxDisplayorder,
    managechallengesSelectedTab: state.managechallengesSelectedTab,
    challengesList: state.manageChallengesList,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openChallengesModal,
  checkContentDashboardStatus,
  insertChallenge,
  getMaxDisplayorder,
  fetchManageChallengesList,
})(
  reduxForm({
    validate,
    form: "AddChallengeForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditChallenge)
);
